import ButtonComponent from '@/Inputs/ButtonComponent';
import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { MiniLoader, cn, storeAssigned } from '@/services/Methods/normalMethods';
import { TaskAlt } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';

function CheckoutStepFour(props) {
    const fieldValue = useFormikContext();
    const {
        handleChangeValidate, checkValidUser, loginSliceloading, formData, _createMarchentProfile, otpPopUp,
        _otpResend, resentStatus, _authenticateOtp, storeToken, rankUpgrad, otp, section, loginErrorMsg, handleChangeFunction, selectedLanguage, setSelectedLanguage, SINGLE_MEMBERSHIPCHECK, setFormData, taxTypeData, countryData
    } = props;

    const handleLanguageChange = (e) => {
        setSelectedLanguage(e.target.value);
    };

    const TaxTypeOptions = taxTypeData.map(item => ({
        value: item.taxIdType,
        label: item.descr,
        shortDescr: item.shortDescr
    }));

    const filteredCountry = countryData.filter(country => country.countryCode === _.upperCase(storeAssigned()));

    const selectedCountry = filteredCountry[0];
    const validTaxTypeValues = selectedCountry
        ? [selectedCountry.personalTaxType, selectedCountry.businessTaxType]
        : [];

    // const FilteredTaxTypeOptions = TaxTypeOptions.filter(item =>
    //     validTaxTypeValues.includes(item.value)
    // );
    const FilteredTaxTypeOptions = TaxTypeOptions.filter(item =>
        [3, 7, 8, 9].includes(item.value) || ['CC', 'RFC', 'RUT', 'NIT'].includes(item.shortDescr)
    );
    const getMaxLength = (taxIdType) => {
        switch (taxIdType) {
            case '7':
                return 13;
            case '8':
                return 13;
            case '3':
                return 11;
            case '9':
                return 9;
            default:
                return 10;
        };
    }
   const applyTaxIdRule = (value) => {
  const cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  let result = '';

  for (let i = 0; i < cleaned.length && i < 13; i++) {
    const char = cleaned[i];

    if (i < 4 && /[A-Z]/.test(char)) {
      result += char;
    }

    else if (i >= 4 && i < 10 && /[0-9]/.test(char)) {
      result += char;
    }

    else if (i >= 10 && /[A-Z0-9]/.test(char)) {
      result += char;
    }
  }

  return result;
};


    console.log("fieldValue?.values?.taxTypefieldValue?.values?.taxType",fieldValue?.values?.taxType);

    return (
        <>
            <div className='flex flex-wrap'>
                <div className='flex flex-wrap items-start w-full xl:mb-[24px] gap-4 mb-6'>
                    <TextFieldComponent
                        name="shipping_phone"
                        type='text'
                        label="Phone"
                        // disabled={!!checkValidUser || (rankUpgrad === 'distributor' && section === "distributorCheckout")}
                        classes="flex-1"
                        value={fieldValue?.values?.shipping_phone}
                        onChange={fieldValue?.handleChange}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.shipping_phone || storeToken?.error}
                        divClass={'w-full  !mb-0'}
                    />
                    {/* sm:max-w-[calc(100%-200px-16px)]   */}
                    {(process.env.NEXT_PUBLIC_OTP_SECTION === "true" ? !checkValidUser : false) &&
                        <>
                            <ButtonComponent type='button'
                                classes={cn(`
                        max-sm:mx-auto !max-w-[200px] px-[15px] pt-[12px] pb-[10px] border-2  rounded-[6px] 
                        2xl:text-[20px] xl:text-[19px] text-[18px] transition-all ease-in-out duration-300`,
                                    {
                                        "!bg-green-500 text-white border-green-500 ": checkValidUser
                                    })}
                                disabled={!!checkValidUser}
                                onClick={() => {
                                    if (!checkValidUser && fieldValue?.values?.shipping_phone) {
                                        _createMarchentProfile({ ...formData, shipping_phone: fieldValue?.values?.shipping_phone })
                                    } else if (!fieldValue?.values?.shipping_phone) {
                                        fieldValue?.setFieldError('shipping_phone', 'This field is required')
                                    }
                                }}>{loginSliceloading ? <MiniLoader /> : checkValidUser ? <span><TaskAlt />  Verified</span> : 'Enter'}</ButtonComponent>
                            <p>Note: Please verify your phone number using enter before going further.</p>
                        </>
                    }
                </div>
                {/* {storeToken?.error && <p className='text-sm mt-1 text-red'>{storeToken?.error}</p>} */}
                {otpPopUp &&
                    <div className='flex items-center flex-wrap items-start w-full xl:mb-[30px] gap-4 mb-6'>
                        <p>Enter Code : </p>
                        <TextFieldComponent
                            divClass="xl:mb-0 sm:mb-0 mb-0  w-full sm:max-w-[calc(100%-200px-32px-90px)]"
                            name='code'
                            type='text'
                            value={otp}
                            label="Code"
                            // placeholder="e.g 123456"
                            onChange={(e) => handleChangeValidate(e?.target)}
                        />
                        <ButtonComponent disabled={!otp} type='button' classes='!mb-0 max-sm:mx-auto max-w-[200px] cursor-pointer py-[13px] transition-all ease-in-out duration-300' onClick={() => {
                            _authenticateOtp(() => {
                                console.log('dddddddddddd')
                            })
                        }}>{loginSliceloading ? <MiniLoader /> : 'Verify'}</ButtonComponent>
                        <p>Enter the code you receive via SMS. You may request another code after one minutes <button type='button' className='anchor-clr hover:underline' onClick={() => _otpResend()}>Resend code</button></p>
                        {resentStatus && <p>{resentStatus}</p>}
                    </div>
                }
                {loginErrorMsg && !loginErrorMsg.includes("WebAlias") && (<p className='text-sm !text-red-500'>{loginErrorMsg}</p>)}


                <div className="relative w-full sm:w-[calc(100%/2-8px)]">
                    <p className="mt-2 text-gray-600 mb-2">Select Language</p>
                    <TextFieldComponent
                        name="select_language"
                        type="select"
                        // label="Select Language"
                        value={selectedLanguage}
                        options={[
                            { value: "Chinese", label: "Chinese" },
                            { value: "English", label: "English" },
                            { value: "French", label: "French" },
                            { value: "German", label: "German" },
                            { value: "Hungarian", label: "Hungarian" },
                            { value: "Italian", label: "Italian" },
                            { value: "Japanese", label: "Japanese" },
                            { value: "Spanish", label: "Spanish" }
                        ]}
                        onChange={handleLanguageChange}
                        onBlur={(e) => fieldValue?.handleBlur(e)}
                        errorMessage={""}
                        divClass="w-full pr-0"
                        classes="pt-0"
                    />
                </div>
            </div>
            {rankUpgrad === 'main_enrollment' && <div className="relative w-full sm:w-[calc(100%/2-8px)] checkout_datepicker pb-2">
                <p className="mt-2 text-gray-600 mb-2">Date of Birth</p>
                <DatePicker
                    name='dob'
                    selected={fieldValue?.values?.dob ? moment(fieldValue.values.dob).toDate() : null}
                    onChange={(date) => {
                        if (date instanceof Date && !isNaN(date)) {
                            const formattedDate = moment(date).format('YYYY-MM-DD');
                            fieldValue.setFieldValue('dob', formattedDate);
                            setFormData(({ ...fieldValue?.values, dob: formattedDate }));
                        }
                    }}
                    onBlur={(e) => {
                        fieldValue.handleBlur(e);
                        setFormData(({ ...fieldValue?.values }));
                    }}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                    wrapperClassName="w-full"
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={new Date()}
                    placeholderText="Select your date of birth"
                />
                {fieldValue.errors?.dob && fieldValue.touched?.dob && (
                    <p className="mt-1 text-sm text-red-500">{fieldValue.errors.dob}</p>
                )}
            </div>}
            {(rankUpgrad === 'main_enrollment') && (storeAssigned() === 'co' || storeAssigned() === 'mx') && (
                <div className='flex flex-wrap gap-4'>
                    <TextFieldComponent

                        name="taxType"
                        type={'select'}
                        label="Tax Type"
                        value={fieldValue?.values?.taxType}
                        onChange={(e) => { 
                            fieldValue?.handleChange(e); setFormData({ ...formData, taxType: e.target.value, taxId: '' }) }}
                        options={FilteredTaxTypeOptions}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                        }}
                        errorMessage={fieldValue?.errors?.taxType}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full pr-0"}
                    />
                    <TextFieldComponent
                        key={fieldValue?.values?.taxType} 
                        name="taxId"
                        type="text"       
                       label="Tax ID"
                        value={fieldValue?.values?.taxId}
                        onChange={(e) => {
                        let value = e.target.value;

                        if (fieldValue?.values?.taxType === "7") {
                            value = applyTaxIdRule(value);
                        } else {
                            value = value.replace(/[^0-9]/g, '');
                        }

                        fieldValue.setFieldValue('taxId', value);
                        setFormData({ ...formData, taxId: value });
                        }}

                        onBlur={fieldValue.handleBlur}
                        errorMessage={fieldValue?.errors?.taxId}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}

                        maxLength={fieldValue?.values?.taxType === "7" ? 13 : getMaxLength(fieldValue?.values?.taxType)}

                        inputMode={fieldValue?.values?.taxType === "7" ? "text" : "numeric"}
                        pattern={fieldValue?.values?.taxType === "7" ? undefined : "[0-9]+"}
                        />

                </div>
            )}
        </>
    )
}

export default CheckoutStepFour;